<template>
  <!--线下任务-->
  <el-row class="alltext">
  <!-- <i class="el-icon-back" @click="Jump">返回</i> -->
  <div class="all">
    <h1 class="center">制定线下任务</h1>
    <el-steps :active="active" finish-status="success">
       <el-step title="任务设置"></el-step>
      <el-step title="培训人员"></el-step>
      <el-step title="完成"></el-step>
    </el-steps>
    <div class="con" v-if="active === 0" style="display: flex;">
          <div class="div_left">
            任务主题：<el-input style="width: 27%;" v-model="upload.theme_input" placeholder="请输入内容"></el-input> <br />
            任务分类：<el-select v-model="upload.class_value" placeholder="请选择" style="margin-top: 8%;">
                     <el-option
                         v-for="item in info.class_list"
                         :key="item.num"
                         :label="item.name"
                         :value="item.num">
                       </el-option>
                     </el-select> <br />
            任务级别：<el-select v-model="upload.level_value" placeholder="请选择" style="margin-top: 8%;">
                     <el-option
                         v-for="item in info.level_list"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
                       </el-option>
                     </el-select> <br />
            培训类型：<el-input style="width: 27%;margin-top: 8%;"  type="text" v-model="upload.type_input" placeholder="请输入内容"></el-input> <br />
          </div>
          <div class="div_right">
            培训时长：<el-date-picker
                     v-model="upload.time_picker"
                     type="daterange"
                      value-format="yyyy-MM-dd"
                     range-separator="至"
                     start-placeholder="开始日期"
                     end-placeholder="结束日期">
                     </el-date-picker><br />
                     培训说明：<el-input style="width:50%;margin-top: 8%;" :autosize="{ minRows: 2, maxRows:999}"  type="textarea" v-model="upload.explain_input" placeholder="请输入内容"></el-input> <br />
            培训内容详情：<el-input style="width: 50%; margin-top: 8%;"  type="textarea"  :autosize="{ minRows: 2, maxRows:999}" v-model="upload.content_input" placeholder="请输入内容"></el-input> <br />


              </div>
                     <div class="con-button">
                      <el-button @click="next(1)">下一步</el-button>
                     </div>
  </div>
     <div class="con" v-if="active === 1" style="display: flex;  ">
        <div class="ercitankuang_left">
            <p style="margin-top: 10px; margin-bottom: 20px;">请选择员工
            <span style="position:absolute;  right: 5%;">
            <el-button   type="danger" icon="el-icon-delete" circle @click="removeper()"></el-button>
            <el-button type="success"  icon="el-icon-check" circle  @click="per_click"></el-button>
            </span></p>
            <el-input  style="margin-top: 0.625rem;" v-model="per_value" placeholder="请输入内容"></el-input> <br />
            <el-tree
            style="height: 280px;overflow: auto;"
                 show-checkbox
                 :data="info.per_list"
                 ref="treeper"
                 node-key="num"
                 :filter-node-method="filterNode"
                :props="setup.defaultProps">
            </el-tree>
        </div>
        <div class="ercitankuang_content"></div>
        <div class="ercitankuang_right">
          您选择的员工是：
          <p v-for="(item,key) in upload.xzper_list">{{item.name}}</p>
        </div>
        <div class="con-button">
         <el-button @click="back(0)">上一步</el-button>
          <el-button @click="train_save">保存</el-button>
        </div>
     </div>
      <div class="con" v-if="active === 2">
       <div class="okclass" v-show="true">
          <div style="text-align:center;"><h3>保存成功</h3><br />
          <img  width="50%" src="../../../../assets/TaskAdd_ok.jpg"  />
          </div>
        </div>
       <div class="okclass" v-show="false">
         <div style="text-align:center;">
           <h3>保存失败</h3>
          <img  width="50%" src="../../../../assets/TaskAdd_fail.jpg"  />
        </div>
       </div>
       <div class="con-button">
        <el-button @click="back(1)">上一步</el-button>
         <el-button @click="Jump()">完成</el-button>
       </div>
      </div>
      </div>
  </el-row>
</template>

<script>
  export default {
    watch: {
         per_value(val) {
           // 根据关键词过滤
           this.$refs.treeper.filter(val);
         },
       },
    name: 'App',
    data() {
      return {
        per_value:'',//选择人员
        active: 0,
        setup:{
          classlever_value:'',//部门级别选择
          xzvideofile_list:[],//选择文档视频
          video_title:'',//视频弹框标题
          video_show:false,//视频文档显示
          defaultProps: {
            children: 'children',
            label: 'name',
          },
        },
        info:{
          class_list: [],
          per_list:[],
          level_list:[{
            value: '0',
            label: '企业级别'
          },  {
            value: '1',
            label: '部门级别'
          },{
            value: '2',
            label: '个人级别'
          },],
        },
        upload:{
         class_value: '' ,//任务分类
         theme_input:'',//任务主题
         explain_input:'',//培训说明
         type_input:'',//培训类型
         content_input:'',//培训内容详情
         level_value:'0',//任务级别
         time_picker:'',//培训时长
         xzper_list:[],//选择人员
        },
      }
    },
    components: {},
    mounted: function() {
     this.get_info();
    },

    methods: {
      get_info(){
        let _this=this
        _this.upload.num=''
        if(_this.$route.query.num && _this.$route.query.num!=''){
          _this.axios.get("/v2/c_train/get_train_info_edit",{params:{'num':_this.$route.query.num,'type':'outline'}}).then(function (res) {
            if (res.status == "200") {
              if (res.data.code == "1") {
                _this.upload.num=_this.$route.query.num
                _this.upload.theme_input=res.data.data.name
                _this.upload.class_value=res.data.data.t_id
                _this.upload.level_value=res.data.data.role_type
                _this.upload.type_input=res.data.data.type
                _this.upload.content_input=res.data.data.content
                _this.upload.explain_input=res.data.data.info
                _this.upload.time_picker= [res.data.data.start_time,
                 res.data.data.end_time]
                _this.upload.xzper_list=res.data.data.companyee
              } else {
                _this.$message.error(res.data.msg);
              }
            } else {
              _this.$message.error("服务器内部错误");
            }
          });
        }else{
        }
        _this.get_train_type()
      },

      get_train_type(){
        let _this=this
        _this.axios.get('/v2/c_train/get_train_type',{params:{'page':'1','limit':'9999'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.info.class_list=res.data.data.data
              _this.get_train_companyee()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },

      get_train_companyee(){
        let _this = this;
        _this.axios.get("/v2/c_train/get_train_companyee_list").then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.info.per_list=res.data.data
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      removeper(){
        let _this=this;
        _this.upload.xzper_list=[];
         _this.$nextTick(function () {
                //Dom更新完毕
                this.$refs.treeper.setCheckedKeys([]);
              });
      },
       filterNode(value, data) {
              if (!value) return true;
              return data.name.indexOf(value) !== -1;
            },
      Jump(){
        this.$router.push({path:'/offline'});
      },
     next(num){
      this.active= num;
      if(num==1){
        if(this.upload.xzper_list.length !=0){
          let list=[];
          for(let i=0;i<this.upload.xzper_list.length;i++){
             list.push(this.upload.xzper_list[i].num);
          }
          this.$nextTick(function () {
                 //Dom更新完毕
                 this.$refs.treeper.setCheckedKeys(list);
               });
        }
      }

     },

     train_save(){
       let _this=this
       _this.axios.post("/v2/c_train/train_outline_save",{data:_this.upload}).then(function (res) {
         if (res.status == "200") {
           if (res.data.code == "1"){
             _this.next(2)
           } else {
             _this.$message.error(res.data.msg);
           }
         } else {
           _this.$message.error("服务器内部错误");
         }
       });
     },

     back(num){
      this.active=num;
      if(num==1){
        if(this.upload.xzper_list.length !=0){
          let list=[];
          for(let i=0;i<this.upload.xzper_list.length;i++){
             list.push(this.upload.xzper_list[i].num);
          }
          this.$nextTick(function () {
                 //Dom更新完毕
                 this.$refs.treeper.setCheckedKeys(list);
               });
        }
      }

     },
      per_click() {
       let a=this.$refs.treeper.getCheckedNodes();
       this.upload.xzper_list=[];
       let j=0;
       for(let i=0;i<a.length;i++){
       if(a[i].hasOwnProperty('s_id')){
         this.$set(this.upload.xzper_list,j,a[i])
         j++;
       }
       }

     },
    }
  }
</script>

<style scoped>
  .okclass{
    display: flex;
    justify-content: center;
    margin-top: 8%;
  }
  .filesee{
    padding-top: 10px;
    max-height: 230px;
    border:0.5px solid black;
    margin-top: 8%;
    width: 50%;
  }
  .filesees{
    padding-top: 10px;
    max-height: 230px;
    border:0.5px solid black;
    margin-top: 2%;
    width: 50%;
  }

 .ercitankuang_left{
    border:1px solid 	#9D9D9D;
    height:400px;
    flex: 1;
    /* overflow:scroll; */
    position:relative;
   }
  .ercitankuang_right{
    border:1px solid 	#9D9D9D;
    height:400px;
    flex: 1;
    overflow:auto;
  }
   .ercitankuang_content{
        flex: 0.1;
      text-align:center;
      height: 400px;
    }
   .alltext{
   margin: 20px;
   background-color: white;
   width: 95%;
   border:1px solid 	#9D9D9D;
   min-height: 900px;
   padding: 20px;
    position:relative;
 }
 .main {
     min-height: calc(100vh - 260px);
     width: 90%;
     margin: 0 15%;
   }
 .con {
     width: 95%;
     margin: 20px ;

   }
   .div_left{
     flex: 1;
     padding-left: 10%;
     margin-top: 10px;
   }
   .div_right{
     flex: 1;
     margin-top: 10px;
     min-height: 400px;
   }
 .center {
     text-align: center;
     margin-top: 20px;

   }
   .con-button {
     /* text-align: center; */
      position:absolute;
        right:10%;
        bottom:20%;

   }
</style>



// WEBPACK FOOTER //
// src/view/company/train/Offline/OfflineAdd.vue